import keys from 'lodash/keys';
import difference from 'lodash/difference';

export default (
  error,
  acceptedKeys,
  enqueueSnackbar,
  funcAcceptedKeys = null,
  func401 = null,
  funcUnacceptedKeys = null,
  funcDataEmpty = null
) => {
  const { data, status } = error.response;
  const variant = 'error';
  if (status === 401) {
    // tell them to login or refresh or something
    return func401
      ? func401()
      : enqueueSnackbar(
          'You are not authorized to do this. Are you logged in?',
          { variant }
        );
  } else if (data) {
    const responseKeys = keys(data);
    const modifiedAcceptedKeys =
      typeof acceptedKeys === 'string' ? [acceptedKeys] : acceptedKeys;
    if (difference(responseKeys, modifiedAcceptedKeys).length === 0) {
      // perform block
      return funcAcceptedKeys ? funcAcceptedKeys() : null;
    }
    // error exists that isn't in the accepted keys
    return funcUnacceptedKeys
      ? funcUnacceptedKeys()
      : enqueueSnackbar(
          'Something went wrong. Please email us at help@jerseywatch.com.',
          { variant }
        );
  }
  // error.response.data is empty
  return funcDataEmpty
    ? funcDataEmpty()
    : enqueueSnackbar(
        'Something went wrong. Please refresh the page and try again.',
        { variant }
      );
};
